import { SaveButton, differenceBetweenTwoObjects } from 'src/admin/core'
import { useFormikContext } from 'formik'
import { useUpdateProgramJockeyOrKennel } from '../../hooks'
import { useAppTranslation, useNotification } from 'src/admin/core/hooks'
import { ProgramJockeyOrKennel } from '../../models'

export const UpdateButton: React.FC<{
  jockeyOrKennel: ProgramJockeyOrKennel
  afterSave?: (promise: Promise<any>, action: string) => void
}> = ({ jockeyOrKennel, afterSave }) => {
  const { updateProgramJockeyOrKennel, loading, error } = useUpdateProgramJockeyOrKennel()
  const form = useFormikContext()
  const { values, dirty, isValid, setSubmitting } = form
  const { label } = useAppTranslation()
  const { successNotification, errorNotification } = useNotification()

  const handleSave = () => {
    const formValues = values as ProgramJockeyOrKennel
    const changes = differenceBetweenTwoObjects(formValues, jockeyOrKennel)

    const response = updateProgramJockeyOrKennel({
      variables: {
        input: {
          id: formValues.id,
          ...changes,
        },
      },
    })
    response
      .then(() => {
        successNotification(label('DATO_ACTUALIZADO'))
      })
      .catch(() => {
        errorNotification(label('ERROR_REGISTRANDO_EL_DATO'))
      })
    if (afterSave) {
      afterSave(response, 'update')
    }
    setSubmitting(false)
  }

  return <SaveButton onClick={handleSave} isLoading={loading} disabled={!dirty} />
}
